<template>
  <v-container fluid>
    <page-header
      title="카카오 알림톡 전송"
      :custom-button-list="customButtonList"
      :useList="buttonUseList"
    />
    <br>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <p class="font-weight-white" dark v-bind="attrs" v-on="on">장애 발생 알림</p>
      </template>
      <span>
        HD현대에너지솔루션입니다.
        현재 서버 장애발생으로 인해 일부 발전소에서 모니터링이 안되는 현상이 발생하고 있습니다.
        빠른 시간 내에 서비스가 정상화되도록 조치 예정이오니, 양해 부탁드립니다.
      </span>
    </v-tooltip>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="usergroup"
          :items="items"
          item-text="txt"
          item-value="val"
          label="유료고객"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-btn class="ma-2" color="#FFDE03" :loading="loading" @click="send('payCus', usergroup, 'failure')">전송</v-btn>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="usergroup2"
          :items="items"
          item-text="txt"
          item-value="val"
          label="무료고객"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-btn class="ma-2" color="#FFDE03" :loading="loading" @click="send('nonPayCus', usergroup2, 'failure')">전송</v-btn>
    </v-row>

    <br>
    <br>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <p class="font-weight-white" dark v-bind="attrs" v-on="on">장애 복구 알림</p>
      </template>
      <span>모니터링 서비스가 정상화 되었습니다. 그 동안 고객님의 이해에 감사드리며, 더욱 안전한 시스템이 되도록 노력하겠습니다.</span>
    </v-tooltip>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="usergroup3"
          :items="items"
          item-text="txt"
          item-value="val"
          label="유료고객"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-btn class="ma-2" color="#FFDE03" :loading="loading" @click="send('payCus', usergroup3, 'recovery')">전송</v-btn>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="usergroup4"
          :items="items"
          item-text="txt"
          item-value="val"
          label="무료고객"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-btn class="ma-2" color="#FFDE03" :loading="loading" @click="send('nonPayCus', usergroup4, 'recovery')">전송</v-btn>
    </v-row>

    <br>
    <br>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <p class="font-weight-white" dark v-bind="attrs" v-on="on">장마철 태양광시설 안전관리 안내 (유료고객)</p>
      </template>
      <span>
        [장마철 태양광시설 안전관리 안내]<br><br>
        장마철 집중호우 및 태풍에 대비하여 태양광발전시설 안전점검을 실시해 주시기 바랍니다.<br><br>
        모듈/구조물 고정상태 확인 / 배수로 및 주변 토사 유실 여부 점검<br>
        인버터/접속반 등 전기설비 방수상태 확인<br>
        낙뢰/호우 시 작업 중지 및 안전장비 착용/안전거리 유지<br>
        침수 발생 시 전문가 검토 후 점검 실시<br><br>
        사전점검이 최고의 예방입니다. 철저한 관리로 안전한 태양광 발전소를 유지하세요.
      </span>
    </v-tooltip>
    <v-row>
      <v-col cols="4">
        <v-select
          v-model="usergroup5"
          :items="items"
          item-text="txt"
          item-value="val"
          label="유료고객"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-btn class="ma-2" color="#FFDE03" :loading="loading" @click="send('payCus', usergroup5, 'rainy')">전송</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { sendAlimtalk } from '@/api/master/master'
import PageHeader from '@/layout/components/PageHeader'

export default {
  name: 'sendTest',
  components: {
    PageHeader
  },
  data() {
    return {
      buttonUseList: [],
      customButtonList: [],
      loading: false,
      usergroup: '',
      usergroup2: '',
      usergroup3: '',
      usergroup4: '',
      usergroup5: '',
      items: [
        { txt: '전체', val: '' },
        { txt: '관리자', val: 'usergroup001' },
        { txt: '본사', val: 'usergroup002' },
        { txt: '대리점', val: 'usergroup003' },
        { txt: 'AS기사', val: 'usergroup004' },
        { txt: '사용자', val: 'usergroup005' },
        { txt: '시공사', val: 'usergroup006' },
        { txt: '안전관리자', val: 'usergroup007' },
        { txt: '시운전', val: 'usergroup008' }
      ]
    }
  },
  methods: {
    async send(searchWord, usergroup, alimtalkType) {
      if (!confirm('알림톡을 발송 하시겠습니까?')) {
        return
      }
      this.loading = true
      try {
        const response = await sendAlimtalk({ search_word: searchWord, usergroup, alimtalkType })
        alert(`발송 완료 (성공: ${response.successCount}건, 실패: ${response.failCount}건)`)
      } catch (e) {
        alert('발송 중 오류가 발생했습니다.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ma-2 {
  color: black;
}
.v-application .ma-2 {
  margin: 15px !important;
}
</style>
